/**
 * Module Event Bus
 *
 * Simple pub/sub for module lifecycle and game events.
 * Handlers run in priority order (lower number = higher priority).
 * Errors in one handler do not prevent others from running.
 */
const subscriptions = [];
export function subscribeModuleEvent(sub) {
    subscriptions.push(sub);
    // Sort by priority (lower = higher priority)
    subscriptions.sort((a, b) => a.priority - b.priority);
    return () => {
        const idx = subscriptions.indexOf(sub);
        if (idx !== -1)
            subscriptions.splice(idx, 1);
    };
}
export async function emitModuleEvent(event, payload = {}) {
    const relevant = subscriptions.filter(s => s.event === event);
    for (const sub of relevant) {
        try {
            await sub.handler(payload);
        }
        catch (err) {
            console.error(`[module-event-bus] Error in ${sub.moduleId} handler for ${event}:`, err);
        }
    }
}
export function clearModuleSubscriptions(moduleId) {
    for (let i = subscriptions.length - 1; i >= 0; i--) {
        if (subscriptions[i].moduleId === moduleId) {
            subscriptions.splice(i, 1);
        }
    }
}
export function getSubscriptionCount(moduleId) {
    if (moduleId)
        return subscriptions.filter(s => s.moduleId === moduleId).length;
    return subscriptions.length;
}
//# sourceMappingURL=module-event-bus.js.map